import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import { getOmniData } from '@src/services/omni-api';
import CommonHeaderStore from '@src/business-components/common-header/store';

let swiperImgRef = null;
let swiperRef = null;
let firstLoad = true;
let firstLoad2 = true;
let stopChange = false;
class AuditionImageStore extends BaseStore {
  commonHeaderStore = new CommonHeaderStore({
    current: 5,
    changeSwiperCallback: id => {
      this.changeNav(id);
    }
  });
  @observable images = [];
  @observable showFeature = false;
  @observable currentImgIndex = 0;
  @observable currentIndex = 0;
  @observable stop = true;
  @observable stop2 = true;
  @observable changeType = 'default'; // 切换类型

  @computed
  get params() {
    const that = this;
    return {
      loop: true,
      slidesPerView: 5,
      spaceBetween: 20,
      centeredSlides: true,
      // freeMode: true,
      watchSlidesVisibility: true, //防止不可点击
      on: {
        init: function() {
          swiperRef = this;
          // that.showFeature = true;
        },
        slideChangeTransitionStart: function() {
          that.currentIndex = this.realIndex;
        },
        click: function() {
          const visibleSlidesIndexes = this.visibleSlidesIndexes;
          const clickedIndex = this.clickedIndex;
          const foundIndex = visibleSlidesIndexes.findIndex(index => index === clickedIndex);
          if (foundIndex > -1) {
            if (foundIndex < 2) {
              this.slidePrev();
            } else if (foundIndex > 2) {
              this.slideNext();
            }
          }
        }
      }
    };
  }

  // @computed
  // get paramsImg() {
  //   const that = this;
  //   return {
  //     loop: true,
  //     effect: 'fade',
  //     autoplay: {
  //       delay: 5000,
  //       disableOnInteraction: false
  //     },
  //     thumbs: {
  //       swiper: swiperRef
  //     },
  //     on: {
  //       init: function() {
  //         swiperImgRef = this;
  //       }
  //     }
  //   };
  // }

  getData = async () => {
    try {
      const res = await getOmniData('channel_cat_1beee26b', [
        {
          dataSourceId: 'ds_cat_eb033770' || '',
          page: 1,
          perPage: 99
        }
      ]);
      const data = res.ds_cat_eb033770?.result?.items || [];
      const images = [];
      data.forEach((item, index) => {
        images.push({
          id: index + 1,
          title: item.title || '',
          img: item.wallpaper?.[0]?.url || '',
          thumbImg: item.wallpaper?.[0]?.url || ''
        });
      });
      this.images = [...images];
    } catch (error) {
      console.log(error);
    }
  };

  changeNav = id => {
    this.$history.replace(`/?currentPage=${id}`);
  };

  changeIndex = changeIndex => {
    if (changeIndex === this.currentIndex) {
      return;
    }
    this.currentIndex = changeIndex;
    swiperRef?.slideToLoop(changeIndex);
  };

  changeSwiper = direction => {
    this.changeType = 'click';
    if (direction === 'prev') {
      swiperRef?.slidePrev?.();
    } else if (direction === 'next') {
      swiperRef?.slideNext?.();
    }
  };

  addScrollEvent = () => {
    window.addEventListener('scroll', this.handleScroll);
  };

  removeScrollEvent = () => {
    window.removeEventListener('scroll', this.handleScroll);
  };

  handleScroll = () => {
    // 判断滚动距离大于100
    const scrollTop = document.documentElement.scrollTop;
    if (scrollTop > 100) {
      if (this.commonHeaderStore.isMax) {
        return;
      }
      this.commonHeaderStore.isMax = true;
    } else {
      this.commonHeaderStore.isMax = false;
    }
  };
  goBack = () => {
    this.$history.replace('/?currentPage=5');
  };
  use() {
    super.use();
    useMount(() => {
      document.body.classList.add('audition-image-page');
      this.addScrollEvent();
      console.log('componentDidMount');
      this.getData();

      return () => {
        document.body.classList.remove('audition-image-page');
        this.removeScrollEvent();
      };
    });
  }
}

export default AuditionImageStore;
